import { commonUtils } from './common_utils';

export const searchAdHistory = {
    cookieName: '_searchHistory',
    cookieExpireTime: 365 * 24 * 60, // Time into minutes,
    previousSearchData: '',
    remove(key) {
        let searchHistoryData = this.getCookieData();
        let results = searchHistoryData.filter(
            (element) => element && Object.keys(element).length !== 0 && element.dateCreated !== key,
            key
        );

        commonUtils.setCookie(this.cookieName, JSON.stringify(results), this.cookieExpireTime);
        if (searchAdHistory.total() === 0) {
            $('#previousSearchHistory').addClass('pointer-events-none disabled-link');
            accessibility.updateDisabledLinkAttributes();
            $.colorbox.close();
        }
    },
    getCookieData() {
        return JSON.parse(commonUtils.getCookie(this.cookieName));
    },
    total() {
        return this.getCookieData() ? this.getCookieData().length : 0;
    },
};

if (searchAdHistory.total()) {
    $('#previousSearchHistory').removeClass('pointer-events-none disabled-link');
    accessibility.updateDisabledLinkAttributes();
}

$(function () {
    const $body = $('body');
    $body.on('click', '.removeHistory', function () {
        searchAdHistory.remove($(this).data('key'));
        $(this).closest('.historyItem').remove();
    });

    // Save search agent from modal
    $body.on('click', '.saveSearchFromPrevSearchHistoryModal', function (e) {
        e.preventDefault();
        let source = $(this).data('source');
        if (!commonUtils.isUserLogin(source)) {
            almaTunnusLogin.init();
            return false;
        }

        if ($(this).data('save-search-url')) {
            globalThis.location.href = $(this).data('save-search-url');
            return false;
        }
        let route = Routing.generate('save_search_history');

        $('#previousSearchHistoryLoader').show();
        const params = `save_search_from=previousSearchHistoryModal&isFromPrevSearchHistoryModal=Y&previousSearchRecordNumber=${$(this).data('record-number')}`;
        $.get(route, params, function (response) {
            $('#previousSearchHistoryLoader').hide();
            $.colorbox.close();
            if (response.redirect_url) {
                location.href = response.redirect_url;
            }

            if (response.status === 'error') {
                alert(Translations.technical_error);
                globalThis.location.reload();
            }
            return undefined;
        }).fail(function () {
            alert(Translations.technical_error);
            globalThis.location.reload();
        });
        return undefined;
    });

    // Open previous search history modal
    $body.on('click', '#previousSearchHistory', function (e) {
        e.preventDefault();
        $.colorbox({
            transition: 'none',
            reposition: 'true',
            resize: 'true',
            initialWidth: previousSearchHistoryRespView().width,
            initialHeight: previousSearchHistoryRespView().height,
            href: $(this).attr('href'),
            onLoad() {
                $('html').css({ overflow: '' });
                $('#colorbox').addClass('previous-searches-nl-modal');
            },
            onClosed() {
                $('#colorbox').removeClass('previous-searches-nl-modal');
            },
        });
    });

    // Function to calculate responsive width
    function previousSearchHistoryRespView() {
        let screenWidth = $(globalThis).width();
        let result = {
            width: '',
            height: '',
        };
        if (screenWidth <= 700) {
            result.width = '336px'; // Mobile view
            result.height = '155px'; // Mobile height
        } else {
            result.width = '688px'; // Desktop view
            result.height = '220px'; // Desktop height
        }
        return result;
    }
});
